import React from "react";
import Icon from "../../../components/AppIcon";
import { useTranslation } from "react-i18next";

const OrderStatusBadge = ({ status, onUpdateStatus, size = "default" }) => {

  const {t} = useTranslation();

  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case "not_confirmed":
        return {
          label: t("not_confirmed"),
          icon: "Clock",
          bgColor: "bg-warning/10",
          textColor: "text-warning",
          borderColor: "border-warning/20",
        };
      case "in_progress":
        return {
          label: t("processing"),
          icon: "Loader",
          bgColor: "bg-primary/10",
          textColor: "text-primary",
          borderColor: "border-primary/20",
        };
      case "shipped":
        return {
          label:t("shipped"),
          icon: "Truck",
          bgColor: "bg-accent/10",
          textColor: "text-accent",
          borderColor: "border-accent/20",
        };
      case "delivered":
        return {
          label: t("delivered"),
          icon: "CheckCircle",
          bgColor: "bg-success/10",
          textColor: "text-success",
          borderColor: "border-success/20",
        };
      case "canceled":
        return {
          label: t("cancelled"),
          icon: "XCircle",
          bgColor: "bg-error/10",
          textColor: "text-error",
          borderColor: "border-error/20",
        };
      default:
        return {
          label: "Unknown",
          icon: "HelpCircle",
          bgColor: "bg-muted",
          textColor: "text-muted-foreground",
          borderColor: "border-border",
        };
    }
  };

  const config = getStatusConfig(status);

  const sizeClasses = {
    sm: "px-2 py-1 text-xs",
    default: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  const iconSizes = {
    sm: 12,
    default: 14,
    lg: 16,
  };

  const handleStatusChange = (newStatus) => {
    if (onUpdateStatus) {
    //  alert(newStatus);
      onUpdateStatus(newStatus);
    }
  };

  return (
    <div
      className={`inline-flex items-center space-x-1.5 rounded-full border font-medium ${config.bgColor} ${config.textColor} ${config.borderColor} ${sizeClasses[size]}`}
    >
      <Icon
        name={config.icon}
        size={iconSizes[size]}
        className={`${config.textColor} ${
          status === "processing" ? "animate-spin" : ""
        }`}
      />
      <span>{config.label}</span>
   
    </div>
  );
};

export default OrderStatusBadge;
